import utils from '@/mixins/utils'
import { api, apiPublic } from '@/plugins/axios.js'
import store from '@/store/store'

export async function rulesCopilot(item) {
  let template = []
  if (item.is_acompanhado == null || item.is_acompanhado == '0') {
    template.push({
      title:
        'Pessoa sem acompanhamento <i class="icofont-sad" style="color: red"></i>',
      text: `Compreende-se por pessoa atendida ou acompanhada, toda aquela que recebe: atendimento individual ou coletivo ou visita domiciliar ou procedimento ou registro de marcadores de consumo alimentar e nutricional, que seja realizado por profissional de saúde ACS, da eSF, eAP, eSB ou eMulti. Recomenda-se que essa pessoa seja acompanhada para atender aos requisitos estabelecidos no componente de vínculo e acompanhamento do cofinanciamento federal da APS.
      `,
    })
  }

  if (item.is_acompanhado != null && item.is_acompanhado == '1') {
    template.push({
      title: 'Pessoa acompanhada &#128079;',
      text: `A equipe está de parabens &#128079;. Essa pessoa recebeu rescentemente acompanhamento de medicina ou enfermagem (${item.ult_fai_esf_eap}), odontologia (${item.ult_fao}), equipe multiprofissional (${item.ult_fai_emulti}), atividade coletiva individualizada (${item.ult_fac}), visita domiciliar pelo ACS (${item.ult_fvdt}), procedimento (${item.ult_fp}) ou registro de marcadores do consumo alimentar e nutricional
      `,
    })
  }

  if (
    item.fci_atualizada == 0 ||
    item.fci_atualizada == null ||
    item.fcdt_atualizada == 0 ||
    item.fcdt_atualizada == null ||
    item.percent_fci_completa == null ||
    item.percent_fci_completa < 100 ||
    item.percent_fcdt_completa == null ||
    item.percent_fcdt_completa < 100
  ) {
    template.push({
      title: 'Cadastro desatualizado ou incompleto',
      text: `Atualizar completamente o cadastro domiciliar (FCDT) e o cadastro individual (FCI) do cidadão.
      `,
    })
  }

  if (item.nu_cpf == null) {
    template.push({
      title: 'O cadastro ainda está sem CPF',
      text: `Recomenda-se atualizar o cadastro informando o número do CPF. Diferentemente do CNS, onde a pessoa pode ter mais de um número, o CPF tende a ter um único para cada pessoa. O uso do CPF está embasado em:

      1 - DECRETO Nº 10.977, DE 23 DE FEVEREIRO DE 2022 que Regulamenta a Lei nº 7.116, de 29 de agosto de 1983, para estabelecer os procedimentos e os requisitos para a expedição da Carteira de Identidade por órgãos de identificação dos Estados e do Distrito Federal, e a Lei nº 9.454, de 7 de abril de 1997, para estabelecer o Serviço de Identificação do Cidadão como o Sistema Nacional de Registro de Identificação Civil. O qual determina que A Carteira de Identidade é única em âmbito nacional e a sua expedição em ente federativo distinto do local de expedição da primeira via será considerada como segunda via do documento. A Carteira de Identidade adota o número de inscrição no Cadastro de Pessoas Físicas - CPF como registro geral nacional previsto no inciso IV do caput do art. 11.;

      2 - LEI Nº 14.534, DE 11 DE JANEIRO DE 2023, Altera as Leis nºs 7.116, de 29 de agosto de 1983, 9.454, de 7 de abril de 1997, 13.444, de 11 de maio de 2017, e 13.460, de 26 de junho de 2017, para adotar número único para os documentos que especifica e para estabelecer o Cadastro de Pessoas Físicas (CPF) como número suficiente para identificação do cidadão nos bancos de dados de serviços públicos;

      3 - PORTARIA GM/MS Nº 2.236, DE 2 DE SETEMBRO DE 2021, que Altera a Seção I do Capítulo III do Título VII da Portaria de Consolidação GM/MS nº 1, de 28 de setembro de 2017, para dispor sobre o Cadastro Nacional de Usuários do SUS e para estabelecer o uso do número de inscrição no Cadastro de Pessoas Físicas (CPF) como forma preferencial de identificação de pessoas na saúde para fins de registro de informações em saúde e instituir o sistema CONECTE SUS CIDADÃO, atual MEU SUS DIGITAL.`,
    })
  }

  let textPublicoAlvo = ''
  if (
    item.sexo == 'F' &&
    Number(item.idade) >= 25 &&
    Number(item.idade) <= 64
  ) {
    textPublicoAlvo += `Cuidado da Saúde da Mulher; \n`
  }
  if (item.st_gestante == '1') {
    textPublicoAlvo += `Cuidado da Gestante; \n`
  }
  if (Number(item.idade) <= 2) {
    textPublicoAlvo += `Cuidado no Desenvolvimento Infantil; \n`
  }
  if (item.st_diabetes == '1') {
    textPublicoAlvo += `Cuidado da Pessoa com Diabetes; \n`
  }
  if (item.st_hipertensao == '1') {
    textPublicoAlvo += `Cuidado da Pessoa com Hipertensão; \n`
  }
  if (Number(item.idade) >= 64) {
    textPublicoAlvo += `Cuidado da Pessoa Idosa; \n`
  }
  if (item.ult_fao == null) {
    textPublicoAlvo += `Cuidado prestado pela eSB, Saúde Bucal; \n`
  }
  if (item.ult_fai_emulti == null) {
    textPublicoAlvo += `Cuidado prestado pela eMulti, equipe multiprofissional. \n`
  }
  if (textPublicoAlvo != '') {
    template.push({
      title: 'É público alvo',
      text: `Esta pessoa é público alvo nos indicadores de qualidade:
      ${textPublicoAlvo}
    `,
    })
  }

  return template
}
